// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dkPV","name":"styles_name__1cK6Z","phone":"styles_phone__13yba"};